import { VERIFICATION_FORM } from '../constants';

export const getPortalVerificationDetails = (payload, props, isVWGoAConfirmationNumber) => ({
    type: VERIFICATION_FORM.VERIFICATION_FORM_DETAILS,
    payload: {
        payload,
        props
    },
    isVWGoAConfirmationNumber,
})